/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeExamStageStatusRequestDto } from '../models';
// @ts-ignore
import type { ExamStageConfigDto } from '../models';
// @ts-ignore
import type { ExamStageConfigRequestDto } from '../models';
// @ts-ignore
import type { ExamStageSummaryDto } from '../models';
// @ts-ignore
import type { InitializeExamStageRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * ExamStageApi - axios parameter creator
 * @export
 */
export const ExamStageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change exam stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeExamStageStatusRequestDto} changeExamStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeExamStageStatus: async (certificationId: number, stageId: number, changeExamStageStatusRequestDto: ChangeExamStageStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('changeExamStageStatus', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('changeExamStageStatus', 'stageId', stageId)
            // verify required parameter 'changeExamStageStatusRequestDto' is not null or undefined
            assertParamExists('changeExamStageStatus', 'changeExamStageStatusRequestDto', changeExamStageStatusRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/status`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeExamStageStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamStageConfig: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamStageConfig', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamStageConfig', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the full state of the exam stage including config, participant count, and exam day count. 
         * @summary Get exam stage summary
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamStageSummary: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamStageSummary', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamStageSummary', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates the exam stage configuration entry for a certification stage of type EXAM. Called once during first-time setup. 
         * @summary Initialize exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {InitializeExamStageRequestDto} initializeExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeExamStage: async (certificationId: number, stageId: number, initializeExamStageRequestDto: InitializeExamStageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('initializeExamStage', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('initializeExamStage', 'stageId', stageId)
            // verify required parameter 'initializeExamStageRequestDto' is not null or undefined
            assertParamExists('initializeExamStage', 'initializeExamStageRequestDto', initializeExamStageRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/initialize`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initializeExamStageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set or update exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ExamStageConfigRequestDto} examStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertExamStageConfig: async (certificationId: number, stageId: number, examStageConfigRequestDto: ExamStageConfigRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('upsertExamStageConfig', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('upsertExamStageConfig', 'stageId', stageId)
            // verify required parameter 'examStageConfigRequestDto' is not null or undefined
            assertParamExists('upsertExamStageConfig', 'examStageConfigRequestDto', examStageConfigRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(examStageConfigRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamStageApi - functional programming interface
 * @export
 */
export const ExamStageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamStageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change exam stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeExamStageStatusRequestDto} changeExamStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeExamStageStatus(certificationId: number, stageId: number, changeExamStageStatusRequestDto: ChangeExamStageStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamStageSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeExamStageStatus(certificationId, stageId, changeExamStageStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamStageApi.changeExamStageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamStageConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamStageConfig(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamStageApi.getExamStageConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the full state of the exam stage including config, participant count, and exam day count. 
         * @summary Get exam stage summary
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamStageSummary(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamStageSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamStageSummary(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamStageApi.getExamStageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates the exam stage configuration entry for a certification stage of type EXAM. Called once during first-time setup. 
         * @summary Initialize exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {InitializeExamStageRequestDto} initializeExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeExamStage(certificationId: number, stageId: number, initializeExamStageRequestDto: InitializeExamStageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamStageSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeExamStage(certificationId, stageId, initializeExamStageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamStageApi.initializeExamStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set or update exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ExamStageConfigRequestDto} examStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertExamStageConfig(certificationId: number, stageId: number, examStageConfigRequestDto: ExamStageConfigRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamStageConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertExamStageConfig(certificationId, stageId, examStageConfigRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamStageApi.upsertExamStageConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamStageApi - factory interface
 * @export
 */
export const ExamStageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamStageApiFp(configuration)
    return {
        /**
         * 
         * @summary Change exam stage status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ChangeExamStageStatusRequestDto} changeExamStageStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeExamStageStatus(certificationId: number, stageId: number, changeExamStageStatusRequestDto: ChangeExamStageStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto> {
            return localVarFp.changeExamStageStatus(certificationId, stageId, changeExamStageStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageConfigDto> {
            return localVarFp.getExamStageConfig(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the full state of the exam stage including config, participant count, and exam day count. 
         * @summary Get exam stage summary
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamStageSummary(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto> {
            return localVarFp.getExamStageSummary(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates the exam stage configuration entry for a certification stage of type EXAM. Called once during first-time setup. 
         * @summary Initialize exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {InitializeExamStageRequestDto} initializeExamStageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeExamStage(certificationId: number, stageId: number, initializeExamStageRequestDto: InitializeExamStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto> {
            return localVarFp.initializeExamStage(certificationId, stageId, initializeExamStageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set or update exam stage config
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {ExamStageConfigRequestDto} examStageConfigRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertExamStageConfig(certificationId: number, stageId: number, examStageConfigRequestDto: ExamStageConfigRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageConfigDto> {
            return localVarFp.upsertExamStageConfig(certificationId, stageId, examStageConfigRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamStageApi - interface
 * @export
 * @interface ExamStageApi
 */
export interface ExamStageApiInterface {
    /**
     * 
     * @summary Change exam stage status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ChangeExamStageStatusRequestDto} changeExamStageStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApiInterface
     */
    changeExamStageStatus(certificationId: number, stageId: number, changeExamStageStatusRequestDto: ChangeExamStageStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto>;

    /**
     * 
     * @summary Get exam stage config
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApiInterface
     */
    getExamStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageConfigDto>;

    /**
     * Returns the full state of the exam stage including config, participant count, and exam day count. 
     * @summary Get exam stage summary
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApiInterface
     */
    getExamStageSummary(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto>;

    /**
     * Creates the exam stage configuration entry for a certification stage of type EXAM. Called once during first-time setup. 
     * @summary Initialize exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {InitializeExamStageRequestDto} initializeExamStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApiInterface
     */
    initializeExamStage(certificationId: number, stageId: number, initializeExamStageRequestDto: InitializeExamStageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageSummaryDto>;

    /**
     * 
     * @summary Set or update exam stage config
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ExamStageConfigRequestDto} examStageConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApiInterface
     */
    upsertExamStageConfig(certificationId: number, stageId: number, examStageConfigRequestDto: ExamStageConfigRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamStageConfigDto>;

}

/**
 * ExamStageApi - object-oriented interface
 * @export
 * @class ExamStageApi
 * @extends {BaseAPI}
 */
export class ExamStageApi extends BaseAPI implements ExamStageApiInterface {
    /**
     * 
     * @summary Change exam stage status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ChangeExamStageStatusRequestDto} changeExamStageStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApi
     */
    public changeExamStageStatus(certificationId: number, stageId: number, changeExamStageStatusRequestDto: ChangeExamStageStatusRequestDto, options?: RawAxiosRequestConfig) {
        return ExamStageApiFp(this.configuration).changeExamStageStatus(certificationId, stageId, changeExamStageStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get exam stage config
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApi
     */
    public getExamStageConfig(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return ExamStageApiFp(this.configuration).getExamStageConfig(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the full state of the exam stage including config, participant count, and exam day count. 
     * @summary Get exam stage summary
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApi
     */
    public getExamStageSummary(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return ExamStageApiFp(this.configuration).getExamStageSummary(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates the exam stage configuration entry for a certification stage of type EXAM. Called once during first-time setup. 
     * @summary Initialize exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {InitializeExamStageRequestDto} initializeExamStageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApi
     */
    public initializeExamStage(certificationId: number, stageId: number, initializeExamStageRequestDto: InitializeExamStageRequestDto, options?: RawAxiosRequestConfig) {
        return ExamStageApiFp(this.configuration).initializeExamStage(certificationId, stageId, initializeExamStageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set or update exam stage config
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {ExamStageConfigRequestDto} examStageConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamStageApi
     */
    public upsertExamStageConfig(certificationId: number, stageId: number, examStageConfigRequestDto: ExamStageConfigRequestDto, options?: RawAxiosRequestConfig) {
        return ExamStageApiFp(this.configuration).upsertExamStageConfig(certificationId, stageId, examStageConfigRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

